import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { useContactGroupActions } from 'contacts/hooks';
import { IContactGroup } from 'contacts/types';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider } from 'core/states';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitSuccess?: (contactGroup: IContactGroup) => void;
  contactGroup: IContactGroup;
}

const schema = yup.object({
  domains: yup
    .array()
    .label(t('labelEmailDomains'))
    .of(yup.object({ id: yup.string(), title: yup.string() })),
});

export const ManageEmailDomainsForm = ({
  isOpen,
  onClose,
  onSubmitSuccess,
  contactGroup,
}: IProps) => {
  const { t } = useTranslation();

  const { updateContactGroup } = useContactGroupActions();

  const onSubmit = () => async (data: { domains: { id: string; title: string }[] }) => {
    const { success, contactGroup: updatedContactGroup } = await updateContactGroup({
      contactGroup: {
        id: contactGroup.id,
        domains: data.domains.map((domain: { id: string; title: string }) => domain.id),
      },
    });

    if (!success) {
      return;
    }

    setTimeout(() => {
      onSubmitSuccess?.(updatedContactGroup);
      onClose();
    }, 1000);
  };

  return (
    <FormProvider
      schema={schema}
      defaultValues={{
        domains: (contactGroup.domains || []).map((domain: string) => ({
          id: domain,
          title: domain,
        })),
      }}
    >
      <Form
        title={t('titleManageEmailDomains')}
        onSubmit={onSubmit}
        onClose={onClose}
        isOpen={isOpen}
      >
        <FormField
          name="domains"
          type={InputType.AUTOCOMPLETE}
          inputProps={{
            label: t('labelEmailDomains'),
            options: [],
            getLabel: (option: { title: string }) => option.title,
            hasCreateOption: true,
            multiple: true,
            enabledOnFocus: false,
          }}
        />
      </Form>
    </FormProvider>
  );
};
